var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisionaiProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.519,
    height: 18.77,
    viewBox: "0 0 19.519 18.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_106346",
    "data-name": "Path 106346",
    d: "M53.649,883.875a11.164,11.164,0,0,0-6.2-5.078,6.75,6.75,0,1,0-6.906,0,11.156,11.156,0,0,0-6.2,5.078.746.746,0,0,0-.1.279.75.75,0,0,0,.143.566.773.773,0,0,0,.223.2.751.751,0,0,0,1.034-.292,9.589,9.589,0,0,1,16.7,0,.752.752,0,0,0,1.034.292.773.773,0,0,0,.223-.2.75.75,0,0,0,.041-.845ZM38.75,873a5.255,5.255,0,1,1,1.539,3.711A5.253,5.253,0,0,1,38.75,873Z",
    transform: "translate(-34.241 -866.247)",
    fill: "#1c1c1c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionaiProfile);
export default __webpack_public_path__ + "static/media/visionai_profile.612810a36a40766658c2732624255655.svg";
export { ForwardRef as ReactComponent };